module.exports = __webpack_public_path__ + "static/media/symbol.4768d7a4.png";